/**
 * Hyphen JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Hyphen
 */
class Hyphen {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
        this.currentLanguage = $( 'html' ).attr( 'lang' );
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.hyphenated = $( '.hyphen' );
    }

    /**
     * Hyphenate all elements with .hyphen class with the help of a plugin called Hypher
     */
    hyphenedElements( ) {
        const Hypher = require( 'hypher' );

        // Create an empty hyphenation let
        let h = '';

        if ( this.currentLanguage == 'fi' ) {

            // Set the current hyphenation
            const finnish = require( 'hyphenation.fi' );
            h = new Hypher( finnish );

        } else if ( this.currentLanguage == 'en-GB' ) {

            // Set the hyphenation
            const english = require( 'hyphenation.en-gb' );
            h = new Hypher( english );

        } else if ( this.currentLanguage == 'sv-SE' ) {

            // Set the hyphenation
            const svenska = require( 'hyphenation.sv' );
            h = new Hypher( svenska );

        }

        // If there is a hyphenation function for the current language, go here
        if ( typeof h.hyphenateText !== 'undefined' ) {

            // Go through each .hyphen class and hyphenate the text
            this.hyphenated.each( ( e, item ) => {

                // Fill the container with .hyphen class with hyphenated content
                $( item ).html( h.hyphenateText( $( item ).text() ) );
            });
        }
    };

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.hyphenedElements();
    }
}

// Export the class reference.
module.exports = Hyphen;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/hyphen.js